export const  i18n = (string) => {
    let langString = string;
    const transStrings = ( window.WPVUE &&  window.WPVUE.strings ) ? window.WPVUE.strings : false;
    if(transStrings){
        const tmp = langString.toLowerCase()
        if(transStrings[tmp]){ langString = transStrings[tmp] }
    }

    return langString
}


export const hasClass = (el, className) => {
    if (el.classList)
        return el.classList.contains(className);
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

export const addClass = (el, className) => {
    if (el.classList)
        el.classList.add(className)
    else if (!hasClass(el, className))
        el.className += " " + className;
}

export const removeClass = (el, className) => {
    if (el.classList)
        el.classList.remove(className)
    else if (hasClass(el, className))
    {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ');
    }
}


export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}


export const postTypeName = name => {
    const WPVUE = window.WPVUE;
    if(!WPVUE && WPVUE.strings) return name;
    return WPVUE.strings[name] || name
}

/**
 * Sort array of objects based on another array
 * https://gist.github.com/ecarter/1423674
 */

export const mapOrder = (array, order, key) => {
    console.log(array)
    array.sort((a, b) => {
      const A = a[key];
      const B = b[key];
      return order.indexOf(A) > order.indexOf(B) ? 1 : -1;
    });
    return array;
  }